/* Kinetic Activewear — global.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ---------- drawers (menu + cart) ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    var d = el.closest('.drawer') || el;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer);
      return;
    }
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) {
      closeDrawer(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { closeDrawer(d); });
    }
  });

  /* ---------- search toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = document.getElementById('SearchBar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) {
      var input = bar.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  /* ---------- carousels ---------- */
  document.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('.carousel');
    if (!track) return;
    wrap.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = track.firstElementChild;
        var step = item ? item.getBoundingClientRect().width + 12 : 300;
        var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
        track.scrollBy({ left: step * dir * 2, behavior: 'smooth' });
      });
    });
  });

  /* ---------- quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var current = document.getElementById('CartDrawer');
        if (!current) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('#CartDrawer');
        if (fresh) {
          current.innerHTML = fresh.innerHTML;
        }
        if (openAfter) openDrawer('CartDrawer');
      })
      .catch(function () {});
  }

  function fetchCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (!window.themeSettings || window.themeSettings.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) { btn.setAttribute('disabled', 'disabled'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCartCount(); })
      .then(function () { return refreshCartDrawer(true); })
      .catch(function (err) {
        var msg = (err && err.description) || 'Could not add to cart';
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = msg; note.classList.remove('hidden'); }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); }
      });
  });

  // cart drawer line changes
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line-qty');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) || 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer(false);
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = btn.getAttribute('data-line-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer(false);
      });
  });

  /* ---------- product variant picker ---------- */
  document.querySelectorAll('[data-product-wrapper]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = wrapper.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-product-price]');
    var addBtn = wrapper.querySelector('[data-add-to-cart]');

    function selectedOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function render() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price--sale"><span class="price__sale">' + formatMoney(variant.price) +
            '</span><span class="price__regular">' + formatMoney(variant.compare_at_price) + '</span></span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Add to cart';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = addBtn.getAttribute('data-label-soldout') || 'Sold out';
        }
      }
      // update option label value text
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var label = group.querySelector('[data-selected-value]');
        var checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
      // update URL
      if (history.replaceState && window.location.pathname.indexOf('/products/') !== -1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    wrapper.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) render();
    });
    render();
  });

  /* ---------- init ---------- */
  fetchCartCount().catch(function () {});
})();
